// action
import {
    UPDATE_PAYMENT,
    UPDATE_PAYMENT_FAIL,
    UPDATE_PAYMENT_SUCCESS,
    UPDATE_PAYMENT_RESET
} from '../action/updatePaymentAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action) {
    switch (action.type) {
        case UPDATE_PAYMENT:
            return {
                ...state,
                apiState: "loading"
            }
        case UPDATE_PAYMENT_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case UPDATE_PAYMENT_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data.data.result,
            }
        case UPDATE_PAYMENT_RESET:
            return initialState
        default:
            return state
    }
}